import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployee from '../reducers/employee.reducer';

export const selectEmployeeState = createFeatureSelector<fromEmployee.State>(
  fromEmployee.employeeFeatureKey
);

export const selectLoggedInemployee = createSelector(selectEmployeeState, state => state.loggedInemployee);
export const selectRestaurantIds = createSelector(selectEmployeeState, state => state.loggedInemployee.chainAcounts?.map(chainAcount => chainAcount.restaurantId));
export const selectRestaurants = createSelector(selectEmployeeState, state => state.loggedInemployee.chainAcounts);
